export default __webpack_public_path__ + "static/media/gallery-wip-bunny-ears_05.1799e6a8.jpg";